import { DefaultButton } from "@fluentui/react";
import styled from "styled-components";
export const SampleProfilesContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-bottom: 1em;
    margin-top: 1em;
    flex-wrap: wrap;
    width: 100%;
    overflow-x: hidden;
`;
export const RowSampleProfile = styled.div`
.shadow{
    width: 98%;
};
& .keyboard-arrow-left{
    position: relative;
    left: -24px;
    z-index: 3;
    color: black !important;
};
& .keyboard-arrow-right{
    position: relative;
    left: -24px;
    z-index: 3;
    color: black !important;
}
`;
export const RowHeaderSampleProfile = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 1em;
`;
export const ColHeaderSampleProfile = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

`;
export const ColSampleProfile = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`;
export const ColSamnpleProfileDescription = styled.div`
`;
export const SampleProfileTitle = styled.p`
    margin-bottom: 8px;
    cursor: default;
    font-family: 'Barlow', sans-serif;
    color: #556769;
    font-weight: 600;
    font-size: 18px;
`;
export const SampleProfileSubTitle = styled.h3`
    margin-bottom: 8px;
    cursor: default;
    font-weight: 600;
    width: 35%;
    font-size: 18px !important;
`;
export const SampleProfileDescription = styled.p`
  color: #95A0A1;
    font-family: 'Barlow', sans-serif;
    cursor: default;
    max-width: 73%;
`;
export const SampleProfileExplicationTitle = styled.h3`
    margin-bottom: 0;
    cursor: default;
    font-weight: 600;
    font-style: uppercase;
    text-align: center;
`;
export const SampleProfileExplicationSubTitle = styled.h3`
    margin-bottom: 0;
    font-weight: 600;
    font-style: uppercase;
    text-align: left;
`;
export const ColSampleProfileAnalysis = styled.div`
    width: 100%;
    display: flex;
    margin: 24px 0px;
`;
export const SampleProfileColLastAnalyisis = styled.div`
    display: flex;
    justify-content: flex-start;
    min-width: 50%;
`;
export const SampleProfileColLastAnalyisisContainer = styled.div`
    width: 100%;
`;
export const SampleProfileCardsContainer = styled.div`
    display: flex;
    flex-direction: row;
    .analysis-management{
        justify-content: flex-end;
    }
`;
export const SampleProfileManagementContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
`;

export const ButtonAnalysis = styled(DefaultButton)`
    padding: 10px 20px;
    background: #CC214F;
    color: white;
    border: 1px solid #CC214F;
    border-radius: 20px;
`;
export const SearchButtonAnalysis = styled(DefaultButton)`
    padding: 10px 20px;
    background: #CC214F;
    color: white;
    border: 1px solid #CC214F;
    border-radius: 20px;
    position: relative;
    top: 6px;
    min-width: 120px;
`;
export const SearchDatesButton = styled(DefaultButton)`
    background-color: #CC214F;
    color: white;
    border: none;
    border-radius: 24px;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    max-width: 96px;
    float: right;
    &:hover
    {
        background-color: #A51B3F;
    }
`;
export const ErrorMessage = styled.span`
    position: absolute;
    display: block;
    width: fit-content;
    top: 83%;
    left: 0;
    margin: 0;
    color: hsl(0, 100%, 63%);
    font-size: 13px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
`;
export const MarketColSearchContainerInner = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    min-height: 280px;
`;
export const MarketColLastAnalyisisContainerInner = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    min-height: 280px;
`;
export const AnalisysPortfolioContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    border: 2px solid red;
`;


export const AnalyisisTableContainerInner = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: row;
`;

export const AnalyisisReportContainerInner = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
`;


export const AnalisysPortfolioTableContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
`;


export const MarketArrow = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const MarketSpacer = styled.div`
    height: 96px;
`;

export const MarketSeparator = styled.div`
    width: 100%;
    height: 1px;
    margin: 8px 0;
`;

export const MarketLineSeparator = styled.div`
    margin-top: 24px;
    margin-bottom: 24px;
    width: 100%;
    height: 1px;
    background-color: #95A0A1;
    opacity: 0.2;  
`;

export const AnalyisisContainer = styled.div`
    margin-bottom: 24px;
    width: 100%;
    justify-content: space-between;
    display: flex;
    flex-direction: row;
`;

export const AnalyisisTableContainer = styled.div`
    width: 72%;
    display: flex;
    flex-direction: column;
    margin-right: 8px;
`;
export const AnalyisisReportContainer = styled.div`
    width: 28%;
    display: flex;
    flex-direction: column;
    margin-left: 8px;
`;